import type { Faq } from '../types/content';

export const faqs: Faq[] = [
  {
    question: 'How will I receive the materials?',
    answer: [
      'HAIR TRANSPLANT BLUEPRINT™ is offered as a digital collection.',
      'The checkout page explains the delivery method, access instructions, and file formats included with your purchase.',
    ],
  },
  {
    question: 'What exactly is included?',
    answer: [
      'Your collection includes six educational volumes and five complementary bonuses covering hair restoration assessment, anatomy, hairline design, donor area considerations, complications education, documentation, and follow-up.',
      'The specific contents are listed throughout this page.',
    ],
  },
  {
    question: 'Is this a physical product?',
    answer: ['No. This is a digital educational product. No physical books or printed materials are included unless expressly stated at checkout.'],
  },
  {
    question: 'Who is this collection for?',
    answer: [
      'The collection is intended for appropriately qualified healthcare professionals and other eligible learners seeking educational references related to hair restoration.',
      'It is not a substitute for professional training or authorization to perform clinical procedures.',
    ],
  },
  {
    question: 'Is this a complete clinical training course?',
    answer: [
      'No. HAIR TRANSPLANT BLUEPRINT™ is an educational reference collection, not a comprehensive surgical training program.',
      'It does not provide certification, supervised practice, or authorization to perform hair transplant procedures.',
    ],
  },
  {
    question: 'Does this replace professional judgment or clinical guidelines?',
    answer: [
      'No. The materials are intended to complement appropriate education and professional references.',
      'Clinical decisions must be made by qualified professionals using current evidence, individual patient circumstances, applicable regulations, and relevant professional guidelines.',
    ],
  },
  {
    question: 'Can I use the materials in any country?',
    answer: [
      'The educational concepts may be relevant to professionals in different countries, but local professional requirements, regulations, and clinical guidelines may differ.',
      'You are responsible for ensuring that your use of the materials is appropriate to your jurisdiction and professional scope.',
    ],
  },
  {
    question: 'Can I download the files?',
    answer: ['The available file formats and download options are specified at checkout. Please review the delivery details before purchasing.'],
  },
  {
    question: 'Is this a recurring subscription?',
    answer: ['No. The advertised price is a one-time payment of $27 USD, with no recurring subscription for this collection.'],
  },
  {
    question: 'What if I decide the collection isn’t right for me?',
    answer: ['Please review the refund policy and eligibility requirements displayed at checkout before purchasing.'],
  },
  {
    question: 'Does this collection guarantee better clinical outcomes?',
    answer: [
      'No. The collection does not guarantee clinical, surgical, or patient outcomes.',
      'Its purpose is to provide organized educational references and documentation resources that can complement appropriate professional learning.',
    ],
  },
];
